export default "__VITE_ASSET__Cb3xTTWn__"